<template lang="html">

  <section class="buttons">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="h2">Medewerkers</h4>
            <div style="margin-top: 30px; margin-bottom: 30px;">
              <div>
              </div>
              <div>
                <select v-if="role === 'admin'" id="officeUsers" name="officeUsers" class="custom-select" v-model="selectedOffice" @change="onChange($event)">
                  <option v-for="office in offices" v-bind:key="office.officeName" v-bind:value="office.value">{{office.officeName}}</option>
                </select>
                <div style="margin-top:25px" v-if="isLoading === true" class="circle-loader"></div>

              </div>
            </div>
<!--            :headers="usersDbHeaders"-->
            <b-table v-if="!isLoading" striped hover  :items="usersDb" :fields="usersDbHeaders"  style="max-width:65%;">
              <template v-slot:cell(user_id)="{ value }">
                <b-button variant="danger" class="icon-btn" @click="deleteUser(value)">
                  <i class="mdi mdi-delete"></i>
                </b-button>
              </template>
              <template v-slot:cell(contact_id)="{ value }">
                <b-button variant="danger" class="icon-btn" @click="deleteUser(value)">
                  <i class="mdi mdi-delete"></i>
                </b-button>
              </template>
            </b-table>
            <div style="margin-top: 50px">
                <b-button class="btn-success" @click="$refs.usermodal.openModal()">
                  <i class="mdi mdi-account-plus">
                  </i>
                </b-button>
              <div class="progress-bar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal ref="usermodal">
      <template>
        <h1>Voeg nieuwe gebruiker toe</h1>
      </template>
      <template v-slot:body>
        <form action="#" @submit="checkForm()">
          <div v-if="errors.length">>
            <b class="text-danger">Fout tijdens het valideren van de ingegeven data:</b>
            <ul>
              <li v-bind:key="error" v-for="error in errors" class="text-danger">{{ error }}</li>
            </ul>
          </div>
          <div class="form-group">
            <label class="label">Voornaam</label>
            <div class="input-group">
              <input type="text" class="form-control" v-model="firstName" ref="firstName" placeholder="Voornaam" id="firstName">
            </div>
          </div>
          <div class="form-group">
            <label class="label">Email</label>
            <div class="input-group">
              <input type="text" class="form-control" v-model="email" ref="email" placeholder="Email" id="email">
            </div>
          </div>
          <div class="form-group">
            <label class="label">Telefoonnummer</label>
            <div class="input-group">
              <input type="text" class="form-control" v-model="phonenumber" ref="phonenumber" placeholder="Telefoonnummer" id="phonenumber">
            </div>
          </div>
          <div class="form-group">
            <label class="label">Wachtwoord</label>
            <div class="input-group">
              <input type="password" class="form-control" v-model="password" ref="password" placeholder="Wachtwoord" id="password">
            </div>
          </div>
          <div class="form-group" v-if="role === 'admin'">
            <label ref="office" class="label">Kantoor</label>
            <div class="input-group">
              <select id="office" name="offices" class="custom-select" v-model="selectedOffice" @change="onChange($event)">
                <option v-for="office in offices" v-bind:key="office.officeName" v-bind:value="office.value">{{office.officeName}}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label ref="office" class="label">Rol</label>
            <div class="input-group ">
              <select v-if="role === 'admin'" name="rolesAdmin" id="rolesAdmin" class="custom-select" v-model="selectedRole" @change="onRoleChange($event)">
                <option v-for="role in rolesAdmin" v-bind:key="role.name" v-bind:value="role.value">{{role.name}}</option>
              </select>
              <select v-else name="rolesOfficemanager" id="rolesOfficemanager" class="custom-select" v-model="selectedRole" @change="onRoleChange($event)">
                <option v-for="role in rolesOfficemanager" v-bind:key="role.name" v-bind:value="role.value">{{role.name}}</option>
              </select>
            </div>
          </div>
        </form>
      </template>
      <template v-slot:footer>
        <b-col class="text-right">
          <div>
            <b-button type="submit" value="submit" class="btn btn-danger" @click="$refs.usermodal.closeModal()">Annuleer</b-button>
            <b-button class="btn btn-success" @click="createUser()">Opslaan</b-button>
          </div>
        </b-col>
      </template>
    </modal>
  </section>

</template>

<script lang="js">
import Modal from '../modals/Modal'
import axios from 'axios'
import store from '../../store'
let server = require('../../server')
export default {
  name: 'buttons',
  components: {
    Modal
  },
  computed: {
    role () {
      return store.state.role
    },
    user () {
      return store.state.user
    },
    office () {
      return store.state.office
    },
    officeString () {
      return store.state.officeString
    }
  },
  async created () {
    let self = this
    try {
      let postData = {
        role: this.role,
        office: this.office
      }
      await axios({
        method: 'post',
        url: server.SERVER_URL + '/get_users_by_role',
        data: postData
      })
        .then(function (response) {
          self.usersDb = response.data
          self.isLoading = false
        })
    } catch (e) {
      console.log('Error while trying to get users!')
      console.log(e)
    }
  },
  data () {
    return {
      users_db: [],
      isLoading: true,
      users: [
        {
          voornaam: 'Mathias',
          email: 'mathias@appwise.be',
          office: 'Sint-Truiden',
          rol: 'employee'
        },
        {
          voornaam: 'Riyan',
          email: 'riyan@appwise.be',
          office: 'Sint-Truiden',
          rol: 'Employee'
        },
        {
          voornaam: 'Gerrit',
          email: 'gerrit@appwise.be',
          office: 'Sint-Truiden',
          rol: 'Officemanager'
        }
      ],
      offices: [
        {
          officeName: 'Sint-Truiden',
          value: 1
        },
        {
          officeName: 'Sint-Niklaas',
          value: 2
        },
        {
          officeName: 'Rumst',
          value: 3
        },
        {
          officeName: 'Pelt',
          value: 4
        },
        {
          officeName: 'Paal',
          value: 5
        },
        {
          officeName: 'Leuven',
          value: 6
        },
        {
          officeName: 'Herentals',
          value: 7
        },
        {
          officeName: 'Hasselt',
          value: 8
        },
        {
          officeName: 'Zaventem',
          value: 9
        },
        {
          officeName: 'Gent',
          value: 10
        }
      ],
      selectedOffice: null,
      selectedRole: null,
      roles: [
        {
          name: 'Admin',
          value: 'admin'
        },
        {
          name: 'Office manager',
          value: 'officemanager'
        },
        {
          name: 'Kantoormedewerker',
          value: 'user'
        }
      ],
      rolesOfficemanager: [
        {
          name: 'Office manager',
          value: 'officemanager'
        },
        {
          name: 'Kantoormedewerker',
          value: 'user'
        }
      ],
      rolesAdmin: [
        {
          name: 'Admin',
          value: 'admin'
        },
        {
          name: 'Office manager',
          value: 'officemanager'
        },
        {
          name: 'Kantoormedewerker',
          value: 'user'
        }
      ],
      firstName: null,
      email: null,
      password: null,
      phonenumber: null,
      errors: [],
      usersDb: [],
      usersDbHeaders: [
        {
          key: 'firstname',
          label: 'Voornaam'
        },
        {
          key: 'email',
          label: 'Emailadres'
        },
        {
          key: 'role',
          label: 'Rol'
        },
        {
          key: 'number',
          label: 'Nummer'
        },
        {
          key: 'user_id',
          label: 'Verwijder medewerker'
        }
      ],
      // eslint-disable-next-line
      emailreg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    }
  },
  methods: {
    createUser () {
      console.log('Checkign form!')
      if (this.role === 'officemanager') {
        this.selectedOffice = this.office
      }
      if ((this.firstName && this.email && this.password && this.selectedOffice && this.selectedRole) && (this.emailreg.test(this.email)) && ((this.password.length > 6))) {
        this.createUserFirebase()
        this.$refs.usermodal.closeModal()
        return true
      } else {
        this.errors = []
        if (!this.firstName) {
          this.errors.push('Voornaam is verplicht.')
        }
        if (!this.email) {
          this.errors.push('Email is verplicht.')
        } else {
          if (!this.emailreg.test(this.email)) {
            this.errors.push('Ongeldig emailadres.')
          }
        }
        if (!this.password) {
          this.errors.push('Wachtwoord is verplicht.')
        } else {
          if (this.password.length < 7) {
            this.errors.push('Wachtwoord moet minstens 6 tekens bevatten.')
          }
        }
        if (!this.selectedOffice) {
          this.errors.push('Selecteer een kantoor.')
        }
        if (!this.selectedRole) {
          this.errors.push('Selecteer een rol.')
        }
      }
    },
    async onChange (event) {
      this.selectedOffice = event.target.value
      this.isLoading = true
      await this.getUsersByOfficeId(this.selectedOffice)
    },
    async deleteUser (userId) {
      let i = this.usersDb.map(item => item.user_id).indexOf(userId)
      this.usersDb.splice(i, 1)
      // this.user_id.splice(i, 1)
      this.$forceUpdate()
      console.log('Preparing to delete user with id: ' + userId)
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/delete_user_by_user_id/' + userId
        })
          .then(async function (response) {
            // console.log('get_contacts_by_campaign_id data = ')
            // await self.refreshStatusContactsDb()
          })
      } catch (e) {
        console.log('Error while trying to get contacts by campaign_id')
        console.log(e)
      }
    },
    onRoleChange (event) {
      this.selectedRole = event.target.value
    },
    async createUserFirebase () {
      this.$firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(async user => {
          const postData = {
            user: user,
            firstname: this.firstName,
            email: this.email,
            office: this.selectedOffice,
            role: this.selectedRole,
            number: this.phonenumber
          }
          try {
            await axios({
              method: 'post',
              url: server.SERVER_URL + '/create_user_firebase',
              data: postData
            }).catch(function (response) {
              console.log('error while trying to create user in db...')
              console.log(response)
            })
          } catch (e) {
            console.log('error while trying to create user...')
            return e
          }
          // todo: get new data from firebase -> refresh visible users
          this.usersDb = this.getUsersByOfficeId(this.office)
          this.$router.push({ path: '/' })
            .catch(error => {
              console.error('Error trying to login: ')
              console.error(error)
            })
        }).catch(err => {
          this.error = err.message
          console.log('LOGIN FAILED ❌')
          console.log(err)
        })
    },
    async getUsers () {
      let self = this
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_users_from_firebase'
        })
          .then(function (response) {
            self.users_db = response.data
            console.log('getUsers response = ')
            console.log(response)
          })
      } catch (e) {
        console.log('Error while trying to get users!')
        console.log(e)
      }
    },
    async getUsersByOfficeId (officeId) {
      let self = this
      console.log(this.office.toString())
      try {
        await axios({
          method: 'get',
          url: server.SERVER_URL + '/get_users_by_office/' + officeId.toString()
        })
          .then(function (response) {
            console.log('data received!')
            self.usersDb = response.data
            console.log('getUsersByOfficeId response = ')
            console.log(response)
            self.isLoading = false
            self.$forceUpdate()
          })
      } catch (e) {
        console.log('Error while trying to get users by officeId!')
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
// utilities
.overflow-hidden {
  overflow: hidden;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
.justify-content-between {
  justify-content: space-between;
}
// reset
button {
  outline: inherit;
  cursor: pointer;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/basic-elements/users.vue